var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7059 20H4.72377C2.39713 20 0.500732 18.1036 0.500732 15.777V4.22304C0.500732 1.89641 2.39713 0 4.72377 0H15.7059C18.0326 0 19.929 1.89641 19.929 4.22304V15.777C19.929 18.1036 18.0382 20 15.7059 20ZM4.72943 2.1285C3.5746 2.1285 2.63489 3.06821 2.63489 4.22304V15.777C2.63489 16.9318 3.5746 17.8715 4.72943 17.8715H15.7116C16.8664 17.8715 17.8061 16.9318 17.8061 15.777V4.22304C17.8061 3.06821 16.8664 2.1285 15.7116 2.1285H4.72943V2.1285Z",
    fill: "#152333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2269 15.426C7.30024 15.426 4.91699 13.0428 4.91699 10.1161C4.91699 7.1894 7.30024 4.80615 10.2269 4.80615C13.1536 4.80615 15.5369 7.1894 15.5369 10.1161C15.5369 13.0428 13.1536 15.426 10.2269 15.426ZM10.2269 6.94032C8.47205 6.94032 7.0455 8.36687 7.0455 10.1217C7.0455 11.8766 8.47205 13.3032 10.2269 13.3032C11.9818 13.3032 13.4084 11.8766 13.4084 10.1217C13.4084 8.36687 11.9818 6.94032 10.2269 6.94032Z",
    fill: "#152333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.899 4.86224C16.899 5.58683 16.3103 6.17557 15.5914 6.17557C14.8668 6.17557 14.2837 5.58683 14.2837 4.86224C14.2837 4.13764 14.8724 3.55457 15.5914 3.55457C16.3103 3.55457 16.899 4.13764 16.899 4.86224Z",
    fill: "#152333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.de025117ed6f53f58b73819658fabfd6.svg";
export { ForwardRef as ReactComponent };